module.exports = __webpack_public_path__ + "static/media/loading1.5cd61e78.png";